import { writable } from 'svelte/store'
import type { Money } from '$lib/types'
import exchangeRatesCache from '$lib/utilities/exchangeRatesCache'
import { exchangeRates as exchangeRatesStore } from './index'
import { get } from 'svelte/store'
import MoneyLib from 'js-money'

export const createExchangeRates = () => {
    const initialValue = exchangeRatesCache

    const { subscribe, update, set } = writable(initialValue)

    return {
        subscribe,
        convertMoneyToCurrency: (money: Money, toCurrency: string): Money => {
            const rates = get(exchangeRatesStore)

            if (money.currency === toCurrency) {
                return money
            }

            if (rates[toCurrency] && rates[toCurrency][money.currency]) {
                const rate = rates[toCurrency][money.currency]
                const convertedAmount = money.amount / rate

                return MoneyLib.fromDecimal(convertedAmount / 100, toCurrency, Math.ceil)
            } else {
                throw Error('Error with currency conversion. Please try again later.')
            }
        },
        updateExchangeRatesFor: (forCurrency, rates) => {
            update(state => {
                state[forCurrency] = rates
                return state
            })
        },
        set,
    }
}
